<template>
    <div>
      <Row>
        <Input size="small" search @on-search="onFilterClick" v-model="keywordFilter" clearable placeholder="名称/联系电话/联系地址"
               style="width: 200px; margin-right: 3px;"></Input>
        <DatePicker size="small" type="daterange" v-model="selectCreateDatetime" placeholder="选择日期"
                    style="margin-right: 3px; width: 200px;"></DatePicker>
        <Button size="small" type="primary" @click="onFilterClick">查询</Button>
        <Dropdown size="small" style="margin-right: 3px" @on-click="DropdownonFilterClick">
          <Button  size="small" type="primary">
            <!--          查询-->
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem name="createDatetime">创建时间</DropdownItem>
            <DropdownItem name="receptDatetime">收款时间</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <!--        <Button size="small" type="primary" style="margin-right: 3px;" @click="onImportOrders">导入订单</Button>-->
                <Button type="primary" size="small" @click="onExportExcel">导出报表</Button>

      </Row>

      <Row style="margin-top: 3px;">
        <div style="width: 100%;">
          <div style="position:relative;">
            <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
            <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content"
                   ref="table"
                   :height="tableHeight"
                   @on-sort-change="sortChange" @contextmenu.prevent.native="onTableRightClick($event)">
            </Table>
            <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
              <Spin size="large"></Spin>
              <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
            </div>
          </div>
          <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator
                @on-change="setPage"
                show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
                style="text-align:right;margin-top:3px;"></Page>

        </div>
      </Row>

      <vehicle-info-detail-modal v-model="vehicleInfoDetailModal" :initValue="vehicleInfoDetailId"
                                 @on-success="onModifySuccess"></vehicle-info-detail-modal>
      <web-table-columns-modal v-model="webTableColumnsModal" :columnList.sync="columns"
                               :tableName="$options.name" @on-column-update="onColumnUpdate"></web-table-columns-modal>
<monitoring-service-confirm-service-datetime-modal @on-success="onModifySuccess" v-model="monitoringServiceConfirmServiceDatetimeModal" :initValue="monitoringServiceConfirmServiceDatetimeId" :listValue="orderList"></monitoring-service-confirm-service-datetime-modal>
<monitoring-service-add-to-remark-modal v-model="addToRemarkModal" :initValue="addToRemarkId" @on-success="onModifySuccess"></monitoring-service-add-to-remark-modal>
      <monitoring-service-refuse-service-modal @on-success="onModifySuccess" v-model="monitoringServiceRefuseServiceModal" :initValue="monitoringServiceRefuseServiceId"></monitoring-service-refuse-service-modal>
      <monitoring-service-callback-client-modal @on-success="onModifySuccess" v-model="monitoringServiceCallbackClientModal" :initValue="monitoringServiceCallbackClientId"></monitoring-service-callback-client-modal>
      <monitoring-service-confirm-refuse-service-modal @on-success="onModifySuccess" v-model="monitoringServiceConfirmRefuseServiceModal" :initValue="monitoringServiceConfirmRefuseServiceId"></monitoring-service-confirm-refuse-service-modal>
<monitoring-service-cancel-modal @on-success="onModifySuccess" v-model="monitoringServiceCancelModal" :initValue="monitoringServiceCancelId"></monitoring-service-cancel-modal>
<monitoring-service-change-business-user-modal v-model="changeBusinessUserModal" :initValue="changeBusinessUserId" @on-success="onModifySuccess"></monitoring-service-change-business-user-modal>
<monitoring-service-confirm-recept-modal @on-success="onModifySuccess" v-model="monitoringServiceConfirmReceptModal" :initValue="monitoringServiceConfirmReceptId" :listValue="orderList"></monitoring-service-confirm-recept-modal>

    </div>
</template>

<script>
import VehicleInfoDetailModal from '@/view/crm/components/vehicle-info-detail-modal'
import MonitoringServiceConfirmServiceDatetimeModal from '@/view/om/components/monitoring-service-confirm-service-datetime-modal'
import MonitoringServiceAddToRemarkModal from '@/view/om/components/monitoring-service-add-to-remark-modal'
import MonitoringServiceRefuseServiceModal from '@/view/om/components/monitoring-service-refuse-service-modal'
import MonitoringServiceCallbackClientModal from '@/view/om/components/monitoring-service-callback-client-modal'
import MonitoringServiceConfirmRefuseServiceModal from '@/view/om/components/monitoring-service-confirm-refuse-service-modal'
import MonitoringServiceCancelModal from '@/view/om/components/monitoring-service-cancel-modal'
import MonitoringServiceChangeBusinessUserModal from '@/view/om/components/monitoring-service-change-business-user-modal'
import MonitoringServiceConfirmReceptModal from '@/view/om/components/monitoring-service-confirm-recept-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'
import { genURLParams } from '@/libs/urlparamhelper'
import axios from '@/libs/api.request'

export default {
  name: 'monitoringservice',
  components: {
    VehicleInfoDetailModal,
    MonitoringServiceConfirmServiceDatetimeModal,
    MonitoringServiceAddToRemarkModal,
    MonitoringServiceRefuseServiceModal,
    MonitoringServiceCallbackClientModal,
    MonitoringServiceConfirmRefuseServiceModal,
    MonitoringServiceCancelModal,
    MonitoringServiceChangeBusinessUserModal,
    MonitoringServiceConfirmReceptModal
  },
  data () {
    return {
      // 第三方监控合约确认服务期
      monitoringServiceConfirmServiceDatetimeModal: false,
      monitoringServiceConfirmServiceDatetimeId: null,

      // 追加备注
      addToRemarkModal: false,
      addToRemarkId: null,

      // 第三方监控客户拒绝服务
      monitoringServiceRefuseServiceModal: false,
      monitoringServiceRefuseServiceId: null,

      // 续费订单回访确认拒绝服务
      monitoringServiceCallbackClientModal: false,
      monitoringServiceCallbackClientId: null,

      // 财务确认拒绝服务
      monitoringServiceConfirmRefuseServiceModal: false,
      monitoringServiceConfirmRefuseServiceId: null,

      // 第三方监控作废
      monitoringServiceCancelModal: false,
      monitoringServiceCancelId: null,

      // 指定业务跟进
      changeBusinessUserModal: false,
      changeBusinessUserId: null,

      // 第三方监控确认收款
      monitoringServiceConfirmReceptModal: false,
      monitoringServiceConfirmReceptId: null,

      // 车辆信息
      vehicleInfoDetailModal: false,
      vehicleInfoDetailId: null,

      // 表格右击组件
      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      // 筛选条件
      businessUserFilter: null,

      // 业务员和安装员
      installers: [],
      marketsales: [],

      // 查询关键字
      keywordFilter: null,

      // 时间选择器
      selectCreateDatetime: [],
      stateFilter: null,
      installedFilter: null,
      qghyptOptionFilter: null,
      uploadStateFilter: null,
      receptFilter: null,
      installerFilter: null,
      businessUserFilter: null,
      billTypeFilter: null,
      isfreeTypeFilter: null,
      gdcdgovVehicleStateFilter: null,
      FilterClickFilter: null,

      // 表格高度
      tableHeight: 160,

      // 表格加载loading
      listLoadding: false,

      // 分页组件
      // 页数
      pageIndex: 1,
      // 每页数量
      pagesizeopts: [30, 50, 100, 200],

      columns: [
        {
          title: '订单号',
          resizable: true,
          key: 'orderNum',
          sortable: 'custom',
          width: 180
        },
        {
          title: '车辆信息',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 190,
          render: (h, params) => {
            let registrationNum = ''
            let vin = ''
            if (params.row.vehicleInfo) {
              registrationNum = params.row.vehicleInfo.registrationNum === null ? '无' : params.row.vehicleInfo.registrationNum
              vin = params.row.vehicleInfo.vin === null ? '无' : params.row.vehicleInfo.vin
            }
            return h('div', [
              h('div', '车牌:' + registrationNum),
              h('div', '车架号:' + vin)
            ])
          }
        },
        {
          title: '客户/分组名',
          resizable: true,
          key: 'vehicleInfo.vehicleInfoGroupId',
          sortable: 'custom',
          ellipsis: 'true',
          width: 180,
          render: (h, params) => {
            let display = []
            if (params.row.vehicleInfo) {
              if (params.row.vehicleInfo.clientInfo) {
                display.push(h('div', '客户信息:' + params.row.vehicleInfo.clientInfo.name + '(' + params.row.vehicleInfo.clientInfo.phoneNum + ')'))
              } else {
                display.push(h('div', '客户信息:无'))
              }
              if (params.row.vehicleInfo.vehicleInfoGroup) {
                display.push(h('div', '分组:' + params.row.vehicleInfo.vehicleInfoGroup.name))
              } else {
                display.push(h('div', '分组:无'))
              }
              return h('div', display)
            } else {
              if (params.row.clientInfo) {
                display.push(h('div', '客户信息:' + params.row.clientInfo.name + '(' + params.row.clientInfo.phoneNum + ')'))
              } else {
                display.push(h('div', '客户信息:无'))
              }
              if (params.row.vehicleInfoGroup) {
                display.push(h('div', '分组:' + params.row.vehicleInfoGroup.name))
              } else {
                display.push(h('div', '分组:无'))
              }
              return h('div', display)
            }
          }
        },
        // {
        //   title: '终端主机号',
        //   resizable: true,
        //   tooltip: 'true',
        //   ellipsis: 'true',
        //   width: 140,
        //   render: (h, params) => {
        //     return h('div', params.row.terminalNum)
        //   }
        // },
        // {
        //   title: '终端类型',
        //   resizable: true,
        //   tooltip: 'true',
        //   ellipsis: 'true',
        //   width: 140,
        //   render: (h, params) => {
        //     return h('div', params.row.positioningDeviceInfo.positioningDeviceModel.name)
        //   }
        // },
        {
          title: '订单状态',
          resizable: true,
          key: 'state',
          tooltip: 'true',
          ellipsis: 'true',
          width: 140,
          filters: [
            { label: '确认续费期', value: 1 },
            { label: '收款', value: 2 },
            { label: '完成', value: 3 },
            { label: '回访', value: 4 },
            { label: '确认停止服务', value: 5 },
            { label: '停止服务', value: 6 },
            { label: '审核', value: 7 },
            { label: '作废', value: 0 },
            { label: '异常', value: -1 }
          ],
          filterMultiple: true,
          filteredValue: [1, 2, 3, 4, 5, 6, 7],
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.stateFilter = []
              val.forEach(item => {
                this.stateFilter.push(genQueryParam('state', 'EQ', item))
              })
            } else {
              this.stateFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            let state = params.row.state
            let step = null
            if (params.row.step != null) {
              step = params.row.step.state
            } else {
              step = 1
            }
            if (state === 1) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待确认续费期')
              } else if (step === 2) {
                return h('div', '已确认续费期')
              } else if (step === 3) {
                return h('div', '确认续费期失败')
              }
            } else if (state === 2) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待收款')
              } else if (step === 2) {
                return h('div', '已收款')
              } else if (step === 3) {
                return h('div', '收款失败')
              }
            } else if (state === 3) {
              return h('div', '完成')
            } else if (state === 4) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待回访')
              } else if (step === 2) {
                return h('div', '已回访')
              } else if (step === 3) {
                return h('div', '回访失败')
              }
            } else if (state === 5) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待确认停止服务')
              } else if (step === 2) {
                return h('div', '已确认停止服务')
              } else if (step === 3) {
                return h('div', '确认停止服务失败')
              }
            } else if (state === 6) {
              return h('div', '停止服务')
            } else if (state === 7) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '审核中')
              } else if (step === 2) {
                return h('div', '审核通过')
              } else if (step === 3) {
                return h('div', '审核不通过')
              }
            } else if (state === 0) {
              return h('div', '作废')
            } else if (state === -1) {
              return h('div', '异常')
            }
          }
        },
        {
          title: '结果',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 160,
          render: (h, params) => {
            if (params.row.step != null) {
              if (params.row.step.result) {
                return h('div', {
                  style: {
                    color: 'red'
                  }
                }, params.row.step.result)
              } else {
                return h('div', {
                  style: {
                    color: 'green'
                  }
                }, '无')
              }
            }
          }
        },
        {
          title: '上次收款总金额',
          resizable: true,
          key: 'lastTotalAmount',
          tooltip: 'true',
          ellipsis: 'true',
          width: 140
        },
        {
          title: '应收总金额',
          resizable: true,
          key: 'totalAmount',
          tooltip: 'true',
          ellipsis: 'true',
          width: 140
        },
        {
          title: '开票类型',
          resizable: true,
          key: 'billType',
          width: 140,
          filters: [
            { label: '增值税发票', value: 1 },
            { label: '增值税专用发票', value: 2 },
            { label: '增值税普通发票', value: 3 },
            { label: '增值税电子专用发票', value: 4 },
            { label: '增值税电子普通发票', value: 5 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.billTypeFilter = []
              val.forEach(item => {
                this.billTypeFilter.push(genQueryParam('billType', 'EQ', item))
              })
            } else {
              this.billTypeFilter = null
            }
            this.setPage(1)
          },
          render: (h, params) => {
            let billType = params.row.billType
            if (billType === 1) {
              return h('div', '增值税发票')
            } else if (billType === 2) {
              return h('div', '增值税专用发票')
            } else if (billType === 3) {
              return h('div', '增值税普通发票')
            } else if (billType === 4) {
              return h('div', '增值税电子专用发票')
            } else if (billType === 5) {
              return h('div', '增值税电子普通发票')
            }
          }
        },
        {
          title: '收款',
          resizable: true,
          key: 'receptDatetime',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          filters: [
            { label: '未收款', value: 0 },
            { label: '已收款', value: 1 }
          ],
          filterMultiple: false,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              if (val[0] === 1) {
                this.receptFilter = genQueryParam('receptDatetime', 'NNULL', null)
              } else {
                this.receptFilter = genQueryParam('receptDatetime', 'EQNULL', null)
              }
            } else {
              this.receptFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.receptDatetime) {
              let d = new Date(params.row.receptDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            } else {
              return h('div', {
                style: {
                  color: 'red'
                }
              }, '未收款')
            }
          }
        },
        {
          title: '旧服务到期时间',
          resizable: true,
          key: 'oldServiceDatetime',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          render: function (h, params) {
            if (params.row.oldServiceDatetime) {
              let d = new Date(params.row.oldServiceDatetime)
              return h('div', d.Format('yyyy年MM月dd日'))
            }
          }
        },
        // {
        //   title: '资料状态',
        //   resizable: true,
        //   key: 'fileReady',
        //   ellipsis: 'true',
        //   tooltip: 'true',
        //   width: 120,
        //   filters: [
        //     { label: '已准备', value: 1 },
        //     { label: '未准备', value: 0 }
        //   ],
        //   filterMultiple: false,
        //   filterRemote: (val) => {
        //     if (val && val.length > 0) {
        //       if (val[0] === 1) {
        //         this.fileReadyFilter = genQueryParam('fileReady', 'EQBOOL', true)
        //       } else {
        //         this.fileReadyFilter = genQueryParam('fileReady', 'EQBOOL', false)
        //       }
        //     } else {
        //       this.fileReadyFilter = null
        //     }
        //     this.setPage(1)
        //   },
        //   render: function (h, params) {
        //     if (params.row.fileReady) {
        //       return h('div', '已准备')
        //     } else {
        //       return h('div', '未准备')
        //     }
        //   }
        // },
        {
          title: '服务到期时间',
          resizable: true,
          key: 'serviceDatetime',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          render: function (h, params) {
            if (params.row.serviceDatetime) {
              let d = new Date(params.row.serviceDatetime)
              return h('div', d.Format('yyyy年MM月dd日'))
            }
          }
        },
        {
          title: '跟进业务员',
          resizable: true,
          key: 'businessUserId',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.businessUserFilter = []
              val.forEach(item => {
                this.businessUserFilter.push(genQueryParam('businessUserId', 'EQ', item))
              })
            } else {
              this.businessUserFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.businessUser) {
              let name = null
              if (params.row.businessUser.realName) {
                name = params.row.businessUser.realName
              } else if (params.row.businessUser.nickName) {
                name = params.row.businessUser.nickName
              } else if (params.row.businessUser.name) {
                name = params.row.businessUser.name
              }
              return h('div', name)
            }
          }
        },
        {
          title: '备注',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'remark',
          width: 180
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          width: 300,
          fixed: 'right',
          render: (h, params) => {
            let display = []

            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.vehicleInfoDetailId = params.row.vehicleInfoId
                    this.vehicleInfoDetailModal = true
                  }
                }
              }, '车辆信息')
            )

            if (!params.row.serviceDatetime) {
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.monitoringServiceConfirmServiceDatetimeId = params.row.id
                      this.monitoringServiceConfirmServiceDatetimeModal = true
                    }
                  }
                }, '确认服务期')
              )
            } else {
              if (params.row.state == 2 || params.row.state == 7) {
                display.push(
                  h('Button', {
                    props: {
                      type: 'warning',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.monitoringServiceConfirmServiceDatetimeId = params.row.id
                        this.monitoringServiceConfirmServiceDatetimeModal = true
                      }
                    }
                  }, '修改服务期')
                )
              }
            }

            display.push(h('Dropdown',
              {
                props: {
                  transfer: true
                }
              },
              [h('Button', '更多'),
                h('DropdownMenu', {
                  slot: 'list'
                }, [
                  h('DropdownItem', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    nativeOn: {
                      click: () => {
                        this.changeBusinessUserId = params.row.id
                        this.changeBusinessUserModal = true
                      }
                    }
                  }, '指派业务员'),
                  h('DropdownItem', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    nativeOn: {
                      click: () => {
                        this.addToRemarkId = params.row.id
                        this.addToRemarkModal = true
                      }
                    }
                  }, '追加备注'),
                  h('DropdownItem', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    nativeOn: {
                      click: () => {
                        this.monitoringServiceConfirmReceptId = params.row.id
                        this.monitoringServiceConfirmReceptModal = true
                      }
                    }
                  }, '确认收款'),
                  h('DropdownItem', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    nativeOn: {
                      click: () => {
                        this.monitoringServiceRefuseServiceId = params.row.id
                        this.monitoringServiceRefuseServiceModal = true
                      }
                    }
                  }, '拒绝服务'),
                  h('DropdownItem', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    nativeOn: {
                      click: () => {
                        this.monitoringServiceConfirmRefuseServiceModal = params.row.id
                        this.monitoringServiceConfirmRefuseServiceId = true
                      }
                    }
                  }, '确认拒绝服务'),
                  h('DropdownItem', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    nativeOn: {
                      click: () => {
                        this.monitoringServiceCallbackClientId = params.row.id
                        this.monitoringServiceCallbackClientModal = true
                      }
                    }
                  }, '回访确认拒绝服务'),
                  h('DropdownItem', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    nativeOn: {
                      click: () => {
                        this.monitoringServiceCancelId = params.row.id
                        this.monitoringServiceCancelModal = true
                      }
                    }
                  }, '作废')
                ])])
            )
            //
            // display.push(
            //   h('Button', {
            //     props: {
            //       type: 'primary',
            //       size: 'small',
            //       disabled: false
            //     },
            //     style: {
            //       marginRight: '5px'
            //     },
            //     on: {
            //       click: () => {
            //         this.addToRemarkId = params.row.id
            //         this.addToRemarkModal = true
            //       }
            //     }
            //   }, '追加备注')
            // )
            // display.push(
            //   h('Button', {
            //     props: {
            //       type: 'primary',
            //       size: 'small',
            //       disabled: false
            //     },
            //     style: {
            //       marginRight: '5px'
            //     },
            //     on: {
            //       click: () => {
            //         this.vehicleInfoDetailId = params.row.vehicleInfoId
            //         this.vehicleInfoDetailModal = true
            //       }
            //     }
            //   }, '车辆信息')
            // )
            // if (params.row.state === 1) {
            //   display.push(
            //     h('Button', {
            //       props: {
            //         type: 'primary',
            //         size: 'small',
            //         disabled: false
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         click: () => {
            //           this.monitoringServiceConfirmServiceDatetimeId = params.row.id
            //           this.monitoringServiceConfirmServiceDatetimeModal = true
            //         }
            //       }
            //     }, '确认服务期')
            //   )
            //   display.push(
            //     h('Button', {
            //       props: {
            //         type: 'primary',
            //         size: 'small',
            //         disabled: false
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         click: () => {
            //           this.monitoringServiceRefuseServiceId = params.row.id
            //           this.monitoringServiceRefuseServiceModal = true
            //         }
            //       }
            //     }, '拒绝服务')
            //   )
            //   display.push(
            //     h('Button', {
            //       props: {
            //         type: 'primary',
            //         size: 'small',
            //         disabled: false
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         click: () => {
            //           this.monitoringServiceCancelId = params.row.id
            //           this.monitoringServiceCancelModal = true
            //         }
            //       }
            //     }, '作废')
            //   )
            // } else if (params.row.state === 2) {
            //   display.push(
            //     h('Button', {
            //       props: {
            //         type: 'primary',
            //         size: 'small',
            //         disabled: false
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         click: () => {
            //           this.monitoringServiceConfirmReceptId = params.row.id
            //           this.monitoringServiceConfirmReceptModal = true
            //         }
            //       }
            //     }, '确认收款')
            //   )
            //   display.push(
            //     h('Button', {
            //       props: {
            //         type: 'primary',
            //         size: 'small',
            //         disabled: false
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         click: () => {
            //           this.monitoringServiceRefuseServiceId = params.row.id
            //           this.monitoringServiceRefuseServiceModal = true
            //         }
            //       }
            //     }, '拒绝服务')
            //   )
            //   display.push(
            //     h('Button', {
            //       props: {
            //         type: 'primary',
            //         size: 'small',
            //         disabled: false
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         click: () => {
            //           this.monitoringServiceCancelId = params.row.id
            //           this.monitoringServiceCancelModal = true
            //         }
            //       }
            //     }, '作废')
            //   )
            // } else if (params.row.state === 3) {
            //
            // } else if (params.row.state === 4) {
            //   display.push(
            //     h('Button', {
            //       props: {
            //         type: 'primary',
            //         size: 'small',
            //         disabled: false
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         click: () => {
            //           this.monitoringServiceConfirmServiceDatetimeId = params.row.id
            //           this.monitoringServiceConfirmServiceDatetimeModal = true
            //         }
            //       }
            //     }, '确认服务期')
            //   )
            //   display.push(
            //     h('Button', {
            //       props: {
            //         type: 'primary',
            //         size: 'small',
            //         disabled: false
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         click: () => {
            //           this.renewalOrderCallbackClientId = params.row.id
            //           this.renewalOrderCallbackClientModal = true
            //         }
            //       }
            //     }, '回访确认拒绝服务')
            //   )
            //   display.push(
            //     h('Button', {
            //       props: {
            //         type: 'primary',
            //         size: 'small',
            //         disabled: false
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         click: () => {
            //           this.monitoringServiceCancelId = params.row.id
            //           this.monitoringServiceCancelModal = true
            //         }
            //       }
            //     }, '作废')
            //   )
            // } else if (params.row.state === 5) {
            //   display.push(
            //     h('Button', {
            //       props: {
            //         type: 'primary',
            //         size: 'small',
            //         disabled: false
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         click: () => {
            //           this.renewalOrderConfirmRefuseServiceId = params.row.id
            //           this.renewalOrderConfirmRefuseServiceModal = true
            //         }
            //       }
            //     }, '停止服务')
            //   )
            //   display.push(
            //     h('Button', {
            //       props: {
            //         type: 'primary',
            //         size: 'small',
            //         disabled: false
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         click: () => {
            //           this.monitoringServiceCancelId = params.row.id
            //           this.monitoringServiceCancelModal = true
            //         }
            //       }
            //     }, '作废')
            //   )
            // } else if (params.row.state === 6) {
            //   display.push(
            //     h('Button', {
            //       props: {
            //         type: 'primary',
            //         size: 'small',
            //         disabled: false
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         click: () => {
            //           this.$Modal.confirm({
            //             title: '提示',
            //             content: '<p>确认重新开通服务</p>',
            //             okText: '是',
            //             cancelText: '否',
            //             onOk: () => {
            //               store.dispatch('PositioningDeviceInfoServ_ReopeningState', {
            //                 params: {
            //                   id: params.row.id
            //                 },
            //                 urlparams: null
            //               }).then(res => {
            //                 console.log(res)
            //                 this.$Message.success('重新开通成功')
            //                 this.refreshPage(this.pageFilter)
            //               }).catch(err => {
            //                 console.log(err)
            //                 this.$Message.error(err)
            //               })
            //             },
            //             onCancel: () => {
            //
            //             }
            //           })
            //         }
            //       }
            //     }, '重新开通')
            //   )
            // } else if (params.row.state === 0) {
            //
            // } else if (params.row.state === -1) {
            //
            // }
            //
            // display.push(
            //   h('Button', {
            //     props: {
            //       type: 'primary',
            //       size: 'small',
            //       disabled: false
            //     },
            //     style: {
            //       marginRight: '5px'
            //     },
            //     on: {
            //       click: () => {
            //         this.changeBusinessUserId = params.row.id
            //         this.changeBusinessUserModal = true
            //       }
            //     }
            //   }, '指派业务员')
            // )

            return h('div', display)
          }
        }
      ], // cloumn

      orderList: [],
      orderIds: [],
      orderListstepstate: null,
      orderListstepresult: null
    }
  },
  methods: {
    /**
         * 右键菜单点击回调
         */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    /**
         * 表格筛选功能
         */
    onColumnUpdate () {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '跟进业务员') {
          this.columns[i].filters = this.marketsales
          break
        }
      }
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '安装员') {
          this.columns[i].filters = this.installers
          break
        }
      }
    },
    // 表格排序
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage()
    },
    /**
         * 表格右键回调
         */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    onExportExcel () {
      let qo1 = null
      let qo2 = null
      let qo3 = null
      let qo4 = null
      let queryParams = []
      let sortParam = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      } else {
        sortParam = genSortParam('createDatetime', false)
      }
      if (this.stateFilter) {
        qo1 = this.stateFilter
      } else {
        qo1 = [
          genQueryParam('state', 'EQ', 1),
          genQueryParam('state', 'EQ', 2),
          genQueryParam('state', 'EQ', 3),
          genQueryParam('state', 'EQ', 4),
          genQueryParam('state', 'EQ', 5)
        ]
      }
      if (this.receptFilter) {
        queryParams.push(this.receptFilter)
      }
      if (this.businessUserFilter) {
        qo2 = this.businessUserFilter
      }
      if (this.billTypeFilter) {
        qo3 = this.billTypeFilter
      }
      if (this.isfreeFilter) {
        qo4 = this.isfreeFilter
      } else {
        qo4 = genQueryParam('isfree', 'EQ', 1)
      }
      if (this.selectCreateDatetime[0] && this.selectCreateDatetime[1]) {
        let startDatetime = new Date(this.selectCreateDatetime[0]).Format('yyyy-MM-dd 00:00:00')
        let endDatetime = new Date(this.selectCreateDatetime[1]).Format('yyyy-MM-dd 23:59:59')
        if (this.FilterClickFilter != null) {
          queryParams.push(genQueryParam(this.FilterClickFilter, 'BTDT', startDatetime, endDatetime))
        } else {
          queryParams.push(genQueryParam('createDatetime', 'BTDT', startDatetime, endDatetime))
        }
      }
      let urlparams = {
        qo1: qo1,
        qo2: qo2,
        qo3: qo3,
        qo4: qo4,
        q: queryParams,
        keyword: this.keywordFilter
      }
      window.location.href = '/api/om/monitoringservice/getreport' + genURLParams(urlparams)
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage()
    },
    onFilterClick () {
      this.FilterClickFilter = null
      this.setPage(1)
    },
    DropdownonFilterClick (name) {
      this.FilterClickFilter = name
      this.setPage(1)
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    },
    // 获取数据
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let qo1 = null
      let qo2 = null
      let qo3 = null
      let qo4 = null
      let qo5 = null
      let qo6 = null
      let qo7 = null
      let qo8 = null
      let qo9 = null
      let queryParams = []
      let sortParam = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      } else {
        sortParam = genSortParam('createDatetime', false)
      }
      if (this.stateFilter) {
        qo1 = this.stateFilter
      } else {
        qo1 = [genQueryParam('state', 'EQ', 1),
          genQueryParam('state', 'EQ', 2),
          genQueryParam('state', 'EQ', 3),
          genQueryParam('state', 'EQ', 4),
          genQueryParam('state', 'EQ', 5),
          genQueryParam('state', 'EQ', 6),
          genQueryParam('state', 'EQ', 7)]
      }
      if (this.installedFilter) {
        queryParams.push(this.installedFilter)
      }
      if (this.qghyptOptionFilter) {
        qo2 = this.qghyptOptionFilter
      }
      if (this.uploadStateFilter) {
        qo3 = this.uploadStateFilter
      }
      if (this.receptFilter) {
        queryParams.push(this.receptFilter)
      }
      if (this.installerFilter) {
        qo4 = this.installerFilter
      }
      if (this.businessUserFilter) {
        qo5 = this.businessUserFilter
      }
      if (this.billTypeFilter) {
        qo6 = this.billTypeFilter
      }
      if (this.gdcdgovVehicleStateFilter) {
        qo7 = this.gdcdgovVehicleStateFilter
      }
      if (this.salesChannelFilter) {
        qo8 = this.salesChannelFilter
      }
      if (this.isfreeTypeFilter) {
        qo9 = this.isfreeTypeFilter
      }
      if (this.selectCreateDatetime[0] && this.selectCreateDatetime[1]) {
        let startDatetime = new Date(this.selectCreateDatetime[0]).Format('yyyy-MM-dd 00:00:00')
        let endDatetime = new Date(this.selectCreateDatetime[1]).Format('yyyy-MM-dd 23:59:59')
        if (this.FilterClickFilter != null) {
          queryParams.push(genQueryParam(this.FilterClickFilter, 'BTDT', startDatetime, endDatetime))
        } else {
          queryParams.push(genQueryParam('createDatetime', 'BTDT', startDatetime, endDatetime))
        }
      }

      store.dispatch('MonitoringServiceServ_GetPage', {
        params: null,
        urlparams: {
          q: queryParams,
          qo1: qo1,
          qo2: qo2,
          qo3: qo3,
          qo4: qo4,
          qo5: qo5,
          qo6: qo6,
          qo7: qo7,
          qo8: qo8,
          qo9: qo9,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    }
  },
  computed: {
    // computeCol() {
    //   let columns = this.columns
    //   columns = columns.filter(col => {
    //     for (var i = 0; i < this.columnsDisplay.length; i++) {
    //       if (this.columnsDisplay[i] === col.title) {
    //         return true
    //       }
    //     }
    //     return false
    //   })
    //   return columns
    // },
    totalElements () {
      if (store.getters.get_MonitoringService_GetPageResult) {
        return store.getters.get_MonitoringService_GetPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_MonitoringService_GetPageResult) {
        return store.getters.get_MonitoringService_GetPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_MonitoringService_GetPageResult) {
        return store.getters.get_MonitoringService_GetPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      // 获取销售员及安装员
      store.dispatch('UserServ_GetAllUsers', {
        params: {},
        urlparams: { roleIds: [8, 14] }
      }).then(() => {
        let installers = store.getters.get_User_GetAllUsersResult
        this.installers = installers.map(item => {
          return { label: item.realName, value: item.id }
        })
        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [7] }
        }).then(() => {
          let marketsales = store.getters.get_User_GetAllUsersResult
          this.marketsales = marketsales.map(item => {
            return { label: item.realName, value: item.id }
          })
          // this.columns[4].filters = this.installers
          // this.columns[13].filters = this.marketsales
          this.onColumnUpdate()
        }).catch(err => {
          this.$Message.error(err)
        })
      }).catch(err => {
        this.$Message.error(err)
      })

      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }

      this.setPage(1)
    })
  }
}
</script>

<style scoped>

</style>
